module.exports = __webpack_public_path__ + "static/snow-report-background-5d582be27365d5737f7d85272a21e326.jpg";